import { NARRATIVE_MESSAGES_JA_V0 } from '@shared/genesis-home-capability-narrative/messages-ja';
import type { RequiredTranslationKeyV0 } from './catalog';

export const JA_JP_MESSAGES_V0: Record<RequiredTranslationKeyV0, string> = {
  ...NARRATIVE_MESSAGES_JA_V0,
  'common.appName': 'Inflomatrix',
  'common.loading': '読み込み中…',
  'common.save': '保存',
  'common.cancel': 'キャンセル',
  'common.close': '閉じる',
  'common.language': '言語',
  'common.languageDescription':
    'インターフェース言語を選択します。通貨およびタイムゾーンとは独立しています。',

  'navigation.today': '今日',
  'navigation.workbench': 'ワークベンチ',
  'navigation.operations': '業務',
  'navigation.objects': 'オブジェクト',
  'navigation.evidenceDecisions': '証憑・決定',
  'navigation.peopleAuthority': '人・権限',
  'navigation.automation': '自動化',
  'navigation.configure': '構成',
  'navigation.operationsConsole': '運用コンソール',

  'states.operation.DRAFT': '下書き',
  'states.operation.PROPOSED': '提案済み',
  'states.operation.READY': '準備完了',
  'states.operation.ADMITTED': '受理済み',
  'states.operation.RUNNING': '実行中',
  'states.operation.WAITING': '待機中',
  'states.operation.NEEDS_ATTENTION': '要対応',
  'states.operation.BLOCKED': 'ブロック中',
  'states.operation.DENIED': '拒否済み',
  'states.operation.FAILED': '失敗',
  'states.operation.COMPENSATING': '補正中',
  'states.operation.COMPLETED': '完了',
  'states.operation.CANCELLED': '取消済み',
  'states.evidence.SUBMITTED': '提出済み',
  'states.evidence.REVIEWED': '確認済み',
  'states.evidence.ACCEPTED': '受諾済み',
  'states.evidence.SATISFIED': '充足済み',
  'states.evidence.REJECTED': '差戻し',
  'states.authority.PENDING': '権限待ち',
  'states.authority.GRANTED': '権限付与済み',
  'states.authority.DENIED': '権限拒否',
  'states.sync.SCAN_OK': 'スキャン成功',
  'states.sync.LOADING': '同期中',
  'states.recovery.AVAILABLE': '復旧可能',
  'states.ai.PROPOSED': 'AI提案',
  'states.ai.ADMITTED': 'システム受理',
  'states.task.READY': 'タスク準備完了',
  'states.task.IN_PROGRESS': 'タスク進行中',
  'states.task.DONE': 'タスク完了',

  'actions.review': '確認',
  'actions.provideInformation': '情報を提供',
  'actions.requestExecution': '実行を要求',
  'actions.approve': '承認',
  'actions.deny': '拒否',
  'actions.start': '開始',
  'actions.resume': '再開',
  'actions.retry': '再試行',
  'actions.cancel': 'キャンセル',
  'actions.requestCompensation': '補正を要求',
  'actions.openRecovery': '復旧を開く',
  'actions.viewReceipt': 'レシートを見る',

  'errors.execution.receivingQuantityMissing.whatHappened': '実行は開始されませんでした。',
  'errors.execution.receivingQuantityMissing.why': '必要な入荷数量が入力されていません。',
  'errors.execution.receivingQuantityMissing.whatChanged': '在庫は変更されていません。',
  'errors.execution.receivingQuantityMissing.whatDidNotChange':
    'その他の業務記録も変更されていません。',
  'errors.execution.receivingQuantityMissing.nextAction':
    '数量を入力してから、もう一度実行を要求してください。',
  'errors.shell.loadFailure.whatHappened': 'ページを読み込めませんでした。',
  'errors.shell.loadFailure.why': '応答を解釈できないか、ネットワークエラーが発生しました。',
  'errors.shell.loadFailure.whatChanged': '画面上のデータは更新されていません。',
  'errors.shell.loadFailure.whatDidNotChange':
    'サーバー上の業務データ・権限・証憑は変更されていません。',
  'errors.shell.loadFailure.nextAction': '再試行するか、復旧経路へ進んでください。',

  'today.title': '今日',
  'today.subtitle': '今対応が必要な業務',
  'today.attention': '注意項目',
  'workbench.title': 'ワークベンチ',
  'workbench.subtitle': '一つの統制された実行',
  'workbench.stage.request': '要求',
  'workbench.stage.intent': '意図',
  'workbench.stage.operation': '業務',
  'workbench.stage.authority': '権限',
  'workbench.stage.evidence': '証憑',
  'workbench.stage.execution': '実行',
  'workbench.stage.result': '結果',
  'workbench.stage.recovery': '復旧',
  'genesis.title': 'Genesis',
  'genesis.stage.start': '開始',
  'genesis.stage.sources': 'ソース',
  'genesis.stage.facts': '事実',
  'genesis.stage.proposals': '提案',
  'genesis.stage.preview': '構成プレビュー',
  'genesis.stage.generate': '生成',
  'genesis.stage.firstOperation': '最初の業務',
  'evidence.title': '証憑・決定',
  'evidence.needsReview': '要確認',
  'evidence.historyTitle': '証跡・決定履歴',
  'evidence.historySubtitle': '完了したレビュー・決定記録',
  'authority.title': '権限',
  'auth.login': 'ログイン',
  'auth.logout': 'ログアウト',
  'settings.personalLanguage': '言語',
  'settings.tenantDefaultLanguage': '既定言語',
  'settings.tenantDefaultLanguageHelp':
    '個人言語設定がないユーザーにのみ適用されます。既存の個人設定は上書きしません。',
  'public.home': 'ホーム',
  'public.product': '製品',
  'public.language': '言語',
  'public.intake.submitFailed.whatHappened': '受付を完了できませんでした',
  'public.intake.submitFailed.why':
    'お問い合わせ・注文受付 API の呼び出しに失敗したか、応答が拒否されました。',
  'public.intake.submitFailed.whatChanged':
    'この画面にエラー状態が表示されています。サーバーに新しい受付が作成されていない可能性があります。',
  'public.intake.submitFailed.whatDidNotChange':
    '既存の受付・注文・権限・セッションはこの失敗では変更されていません。',
  'public.intake.submitFailed.nextAction': '内容を確認してから再試行してください。',
  'public.intake.waitingReason': '受付を処理しています。完了するまでお待ちください。',
  'public.intake.waitingRequired': '受付 API の応答',
  'public.intake.receipt.areaLabel': '公開受付',
  'public.intake.receipt.whatChanged': '受付は受理（accepted）され、確認待ちキューに入りました。',
  'public.intake.receipt.whatDidNotChange': '実行（executed）されていません。受理 ≠ 実行です。',
  'public.receipt.orderReceived': '注文を受け付けました',
  'public.receipt.requestReceived': 'リクエストを受け付けました',
  'public.receipt.qty': '数量',
  'public.receipt.total': '合計',
  'public.receipt.submitted': '受付日',
  'public.receipt.acceptedNotExecuted': '受理済み（accepted）— まだ実行（executed）されていません',
  'public.actionError.PARENT_NOT_FOUND': '元の受付が見つかりません。',
  'public.actionError.PARENT_SCOPE_MISMATCH': 'この受付に対する権限がありません。',
  'public.actionError.ACTION_NOT_ALLOWED': '現在の状態ではこのリクエストを実行できません。',
  'public.actionError.DUPLICATE_ACTION': '同じリクエストがすでに処理中です。',
  'public.actionError.VALIDATION_FAILED': '入力内容を確認してください。',
  'public.actionError.POLICY_NOT_FOUND': 'リクエストポリシーが見つかりません。',
  'public.actionError.fallback':
    'リクエストの送信に失敗しました。しばらくしてから再試行してください。',
  'public.actionError.disabled': '現在このリクエストは利用できません。',
  'public.actionError.successAccepted':
    'リクエストは受理（accepted）されました。まだ実行（executed）されていません。',
  'public.actionError.failure.whatHappened': '後続リクエストを送信できませんでした',
  'public.actionError.failure.whatChanged':
    'この画面にエラーが表示されています。後続リクエストが作成されていない可能性があります。',
  'public.actionError.failure.whatDidNotChange':
    '元の受付・実行状態・権限はこの失敗では変更されていません。',
  'public.actionError.failure.nextAction':
    '理由を確認して再試行するか、参照情報とともにサポートへ連絡してください。',
  'legal.privacy': 'プライバシー',
  'legal.terms': '利用規約',
  'portal.gateway': 'ポータル',
  'configure.title': '構成',
  'console.title': '運用コンソール',
  'operations.title': '業務',
  'operations.subtitle': '業務タイプと実行・例外を管理します',
  'objects.title': 'オブジェクト',
  'objects.subtitle': '運用オブジェクトの文脈と関連業務',
  'people.title': '人・権限',
  'automation.title': '自動化',
  'decisions.title': '決定',
};
